<template>
  <div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >

    <el-table-column label="等级"  align="center"> 
        <template slot-scope="scope">
        {{ scope.row.number }}
        </template>
    </el-table-column>

    <el-table-column label="第一比率" align="center">
        <template slot-scope="scope">
          {{ scope.row.firRate }}
        </template>
    </el-table-column>
    <el-table-column label="第二比率"  align="center">
        <template slot-scope="scope">
          {{ scope.row.secRate }}
        </template>
    </el-table-column>

    <el-table-column  label="第三比率"  align="center">
        <template slot-scope="scope">
          {{ scope.row.thrRate }}
        </template>
    </el-table-column>

    <el-table-column  label="描述"  align="center">
        <template slot-scope="scope">
          {{ scope.row.desc || '无' }}
        </template>
    </el-table-column>

    <el-table-column class-name="status-col" label="操作" width="180" align="center">
      <template slot-scope="scope">
        <el-button type="text" size="mini" @click="editBtn(scope.row)">编辑</el-button>
        </template>
    </el-table-column>

    </el-table>

    <editMulti ref="editMulti" />
  </div>
</template>

<script>
import { lookMultiApi } from '@/api/money.js'
const editMulti = () => import("./components/editMulti");
export default {
  components: {
    editMulti
  },
  data () {
    return {
      list: null,
      listLoading: false,
    }
  },
  created () {
    this.fetchData()
  },

  methods: {
    // 请求表单数据
   async fetchData () {
     try {
        this.listLoading = true
        let res = await lookMultiApi()
        this.listLoading = false
        if(res.code !== 200) return
        this.list = res.data
     } catch (e) {
       this.listLoading = false
       window.console.log(e)
     }
    },
      editBtn(row) {
    this.$refs.editMulti.editForm = row
    this.$refs.editMulti.dialogFormVisible = true
  }
  },


}
</script>

<style lang="less" scoped>

.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
    margin-left: 10px;
}
</style>
